<template lang="pug">
	.download-video(v-if="showed && Project.SelectedProject")
		.card
			.card-header
				span {{cardTitle}}
			.card-body.collapse.show
				.download-fetching(v-if="state === 'fetching'")
					.icon.fa.fa-spinner.fa-spin
				.download-log(v-else-if="state === 'new-video'" ref="downloadLog")
				.download-exists(v-else-if="state === 'existing-video'")
					span {{`Video for this project already exists. Do you want to ${scope} it or generate a new one?`}}
			.card-footer
				.exists-button-group(v-if="state === 'existing-video'")
					button.btn.btn-dark(@click="close()") Hide
					button.btn.btn-primary(@click="scope === 'download' ? download() : upload()") {{scope.replace(/^./, scope[0].toUpperCase())}}
					button.btn.btn-secondary(@click="newVideo()") Generate
				button.btn.btn-dark(v-else @click="close()") Hide
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Template } 		from './../../services/Template'
	import { Project } 			from './../../services/Project'


	export default {
		name: "DownloadVideo",
		mixins: [Screen],
		screen: {
			events: {
				"Video Download Progress": function (projectId, data) {
					if (projectId === Project.SelectedProject.id) {
						if (this.$refs.downloadLog) this.$refs.downloadLog.innerHTML += '<br />' + data;
					}
				},
				"Video Exists For Project": function (projectId, exists) {

					if (projectId === Project.SelectedProject.id) {

						if (exists) this.state = 'existing-video';
						else this.newVideo();

					}

				},
			}
		},
		components: {
		},
		data() {

			this.state = 'fetching';
			this.Template = Template;
			this.Project = Project;
			this.scope = 'download';

			this.cardTitle = 'Download Project Video';
			return {
				showed: false,
			};

		},
		computed: {
		},
		methods: {
			collectData(event, params) {

				if (event !== 'show') return;

				this.params = params;

				this.scope = params.scope || 'download';

				switch (params.scope) {
					case 'download':
						this.cardTitle = 'Download Project Video';
						break;
					case 'upload':
						this.cardTitle = 'Upload Project Video to AmazonS3';
						break;
				}

				this.state = 'fetching';

				if (Project.SelectedProject) {
					this.$nextTick(() => {
						Server.sendToSocket({
							DoesVideoExistForProject: {
								projectId: Project.SelectedProject.id
							}
						});
					});
				}

			},

			newVideo() {


				if (!this.scope || !Project.SelectedProject) return;

				if (this.scope === 'download') {
					Server.sendToSocket({
						DownloadCreative: {
							projectId: Project.SelectedProject.id,
							releaseType: 'video'
						}
					});

				} else if (this.params && this.scope === 'upload') {


					if (this.params.uploadTo === 'amazon') {

						Server.sendToSocket({
							UploadCreativeVideoToAmazonS3: {
								projectId: Project.SelectedProject.id,
								releaseType: 'video',
								templateFolder: this.params.templateFolder,
								projectFolder: this.params.projectFolder,
								region: this.params.region
							}
						});

					}

				}

				this.state = 'new-video';

				this.$forceUpdate();

				this.$nextTick(() => {
					if (this.$refs.downloadLog) this.$refs.downloadLog.innerText = 'Starting video generation';
				});

			},

			upload() {

				if (Project.SelectedProject && this.params && this.scope === 'upload') {

					if (this.params.uploadTo === 'amazon') {

						Server.sendToSocket({
							UploadCreativeVideoToAmazonS3: {
								projectId: Project.SelectedProject.id,
								releaseType: 'video',
								templateFolder: this.params.templateFolder,
								projectFolder: this.params.projectFolder,
								region: this.params.region,
								useExistingVideo: true,
								saveFolders: this.params.saveFolders
							}
						});

						this.state = 'new-video';

						this.$forceUpdate();

					}

				}

			},

			download() {

				Server.sendToSocket({
					DownloadCreative: {
						projectId: Project.SelectedProject.id,
						releaseType: 'video',
						force: true
					}
				});

				this.close();

			},

			close() {

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.download-video
		position: absolute
		left: 0
		top: 0
		right: 0
		bottom: 0
		z-index: 2000
		background-color: rgba(0,0,0,.6)

		>.card
			width: 500px
			margin: auto
			position: absolute
			top: 0
			bottom: 0
			left: 0
			right: 0
			height: fit-content

			.download-exists
				text-align: center
				font-size: 16px

			.download-fetching
				display: flex
				font-size: 50px

				>.icon
					margin: auto

			.download-log
				height: 300px
				background-color: #30353a
				border-radius: 5px
				border: 1px solid #24282c
				padding: 10px
				overflow-y: auto
				overflow-x: auto

			::-webkit-scrollbar
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(255,255,255,0.2)
				background-clip: content-box
				border-color: transparent
				border-style: solid
				border-width: 1px 2px
				border-radius: 5px

			>.card-footer
				background-color: #353b41
				border-top: 1px solid #24282c

				>.exists-button-group
					display: flex
					justify-content: space-between


</style>

